import { Validators } from '@angular/forms';

export const indiOrderNumberValidator = Validators.pattern('^(VO-|MNC-|SCSN-|ACC2-|ACC1-|ACC-|obcc-test-)?0\\d{7}$');
